export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10709.dff45342.jpg";